import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Transactions from './pages/Transactions';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import Backups from './pages/Backups';
import Agency from './pages/Agency';
import AdminPanel from './pages/AdminPanel';
import Staff from './pages/Staff';
import PackageTours from './pages/PackageTours';
import './index.css';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{
      display:'flex', alignItems:'center', justifyContent:'center', height:'100vh',
      background:'var(--surface-0)', color:'var(--fg-3)', fontSize:13.5,
    }}>
      Yükleniyor…
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/register" element={user ? <Navigate to="/" replace /> : <Register />} />
      <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
      <Route path="/islemler" element={<PrivateRoute><Transactions /></PrivateRoute>} />
      <Route path="/raporlar" element={<PrivateRoute><Reports /></PrivateRoute>} />
      <Route path="/personel" element={<PrivateRoute><Staff /></PrivateRoute>} />
      <Route path="/acente" element={<PrivateRoute><Agency /></PrivateRoute>} />
      <Route path="/acente/paket-turlar" element={<PrivateRoute><PackageTours /></PrivateRoute>} />
      <Route path="/admin" element={<PrivateRoute><AdminPanel /></PrivateRoute>} />
      <Route path="/ayarlar" element={<PrivateRoute><Settings /></PrivateRoute>} />
      <Route path="/yedekler" element={<PrivateRoute><Backups /></PrivateRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
